import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { MarkdownView } from "../components/MarkdownView.tsx";
import { TopBar } from "../components/TopBar.tsx";

interface Releases {
  version: string;
  sha: string | null;
  markdown: string;
}

/** Renders CHANGELOG.md — what each version changed, newest first — with the deployed version and commit on top. */
export function ReleasesPage() {
  const navigate = useNavigate();
  const [data, setData] = useState<Releases | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    fetch("/api/releases", { credentials: "same-origin" })
      .then((r) => (r.ok ? (r.json() as Promise<Releases>) : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then(setData)
      .catch((e: Error) => setError(e.message));
  }, []);
  return (
    <div className="flex h-full flex-col">
      <TopBar crumbs={[{ label: "Release notes" }]} query="" onQuery={(q) => navigate(q ? `/issues?q=${encodeURIComponent(q)}` : "/issues")} onCreate={() => navigate("/issues")} />
      <div className="flex-1 overflow-auto px-8 py-5">
        {error && <div className="text-danger">{error}</div>}
        {data && (
          <div className="max-w-3xl">
            <div className="mb-4 flex items-center gap-2 text-sm text-muted">
              <span className="rounded bg-sunken px-2 py-0.5 font-mono text-ink">v{data.version}</span>
              {data.sha && <span className="rounded bg-sunken px-2 py-0.5 font-mono">{data.sha}</span>}
              <span>is what this server runs</span>
            </div>
            <MarkdownView text={data.markdown} className="prose-releases" />
          </div>
        )}
      </div>
    </div>
  );
}
